import { defineStore } from "pinia";

export const useBalanceStore = defineStore("balance", {
  state: () => ({
    balanceInitialized: false,
    balance: undefined,
  }),
  getters: {
    isBalanceInitialized: (state) => state.balanceInitialized,
    getBalance: (state) => state.balance,
  },
  actions: {
    setNewBalance(newBalance) {
      this.balance = newBalance;
    },
    setBalanceInitialized() {
      this.balanceInitialized = true;
    },
  },
});
